module.exports = __webpack_public_path__ + "static/assets/9392037f116313304b8b83e92daf9eae.png";